import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import { TopicThread } from 'models/topicThread';
import './removedCover.html';

export interface CommentRemovedCoverVMConfig {
    comment: SubscribableOrNullableValue<TopicThread>
}

@injectable()
export default class CommentRemovedCoverVM {
    title: Subscribable<string>

    constructor(
        @inject(wccModules.componentConfig) config: CommentRemovedCoverVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
    ) {
        const comment = ko.flattenComputed(config.comment);
        const parentId = comment.pluck('parentId', '');
        const isReply = parentId.is(id => id.length > 0);
        const isDeleted = comment.pluck('isDeleted', false);        

        this.title = comment.pluck(c => isReply() ? labels.ReplyHasBeenDeleted : labels.CommentHasBeenDeleted, '');

        const isVisible = ko.pureComputed(() => isDeleted());

        ko.applyBindingsToNode(info.element, {
            'visible': isVisible,

            'css': {
                'wcc-dark-cover': true
            }
        }, this);
    }
}